import { render, staticRenderFns } from "./ChallengeNotification.vue?vue&type=template&id=52aa5350&scoped=true&"
import script from "./ChallengeNotification.vue?vue&type=script&lang=js&"
export * from "./ChallengeNotification.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeNotification.vue?vue&type=style&index=0&id=52aa5350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa5350",
  null
  
)

export default component.exports